import React from 'react'

const Container = props => <div className="container mx-auto px-4" {...props} />

export default Container
